/* eslint-disable react/no-unstable-nested-components */
import { Fragment, useEffect, useRef } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Slider from 'react-slick';
import HomeBannerDesktopTemplate from './HomeBannerDesktopTemplate';
import BANNERS from '../../constants/homeBanner';
import HomeBannerMobileTemplate from './HomeBannerMobileTemplate';

const HomeBannerSection = () => {
  const isMobile = useMediaQuery(useTheme().breakpoints.down('md'));

  let sliderRef = useRef();
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <img src="/images/left-arrow.png" alt="Izquierda" />,
    nextArrow: <img src="/images/right-arrow.png" alt="Derecha" />,
    appendDots: (dots) => (
      <Box
        style={{
          position: 'relative',
          top: '-120px',
        }}
      >
        <ul style={{ margin: '0px' }}>{dots}</ul>
      </Box>
    ),
  };

  const init = () => {
    setTimeout(() => { sliderRef.slickNext(); }, 3000);
  };

  useEffect(() => { init(); }, []);

  return (
    <Box className="homebanner">
      <Slider {...settings} style={{ margin: '0px', height: '100vh' }} ref={(slider) => { sliderRef = slider; }}>
        {BANNERS.map((banner) => (
          <Fragment key={banner.title}>
            {isMobile ? (
              <HomeBannerMobileTemplate banner={banner} />
            ) : (
              <HomeBannerDesktopTemplate banner={banner} />
            )}
          </Fragment>
        ))}
      </Slider>
    </Box>
  );
};

export default HomeBannerSection;
